import React from 'react';
import Avatar from '../../../components/UI/Avatar/Avatar';
import Modal from '../../../components/UI/Modals/Modal';
import { ICustomer } from '../../../store/slices/customers';
import classes from './SelectCustomerModal.module.css';
import PrimaryButtonV2 from '../../../components/UI/Buttons/PrimaryButtonV2';
import moment from 'moment';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { fetchGenders, Gender, selectGenders } from '../../../store/slices/gender';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  customer: ICustomer;
  onBookTestWithCustomer: () => void;
};
const SelectCustomerModal: React.FC<Props> = ({
  isOpen,
  onClose,
  customer,
  onBookTestWithCustomer,
}) => {
  const dispatch = useAppDispatch();
  const { translations } = useTranslation();
  const genders: Gender[] = useAppSelector(selectGenders);

  React.useEffect(() => {
    dispatch(fetchGenders());
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      divider
      containerPadding={'80px 40px'}
      header={translations('customer.search').toString()}
      width={'50%'}
      maxWidth={'700px'}
    >
      <div className={classes.container}>
        <div className={classes.fieldsContainer}>
          <div className={classes.fields}>
            <div className={classes.avatarContainer}>
              <Avatar width={60} height={60} />
              <div style={{ minWidth: 10 }} />
              <div className={classes.infoContainer}>
                <div style={{ paddingLeft: 0 }} className={classes.label}>
                  {translations('full.name')}
                </div>
                <div style={{ paddingLeft: 0 }} className={classes.value}>
                  {`${customer.person_firstname} ${customer.person_lastname}`}
                </div>
              </div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('date.of.birth')}</div>
              <div className={classes.value}>
                {moment(customer.person_birthdate).format('dd.MM.yyyy')}
              </div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('gender')}</div>
              <div className={classes.value}>
                {genders.find((gender) => gender.gender_id === customer.person_gender_id)?.gender}
              </div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('mobile_number')}</div>
              <div className={classes.value}>{customer.person_mobile_phone}</div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('email')}</div>
              <div className={classes.value}>{customer.person_email}</div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('address')}</div>
              <div className={classes.value}>
                {(customer?.house_number ? `${customer.house_number}, ` : '') +
                  (customer?.street ? `${customer?.street}, ` : '') +
                  (customer?.city ? `${customer?.city}` : '')}
              </div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('postal_code')}</div>
              <div className={classes.value}>{customer.postcode}</div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              <div className={classes.label}>{translations('country')}</div>
              <div className={classes.value}>{customer.country}</div>
            </div>
          </div>
          <div className={classes.fields}>
            <div className={classes.infoContainer}>
              {/* <div className={classes.label}>Nationality</div>
              <div className={classes.value}>{customer.nationality_name}</div> */}
            </div>
          </div>
          {customer.person_identity_number && (
            <div className={classes.fields}>
              <div className={classes.infoContainer}>
                <div className={classes.label}>{translations('passaport_number')}</div>
                <div className={classes.value}>{customer.person_identity_number}</div>
              </div>
            </div>
          )}
        </div>
        <div className={classes.buttonsContainer}>
          <PrimaryButtonV2
            onClick={onBookTestWithCustomer}
            text={translations('select.customer')}
            disabled={false}
            containerStyle={{
              margin: 10,
            }}
            buttonStyle={{
              height: 50,
              padding: '0 20px',
            }}
          />
          <PrimaryButtonV2
            onClick={onClose}
            text={translations('search.again')}
            invertedColors
            disabled={false}
            containerStyle={{
              margin: 10,
            }}
            buttonStyle={{
              height: 50,
            }}
          />
        </div>
      </div>
    </Modal>
  );
};
export default SelectCustomerModal;
